import { createClient } from '@supabase/supabase-js';

// Supabase client — shared instance for the app.
// Values match the existing hardcoded config in
// src/pages/creative-generator/components/BrandedModeForm.js
// (the project does not use REACT_APP_SUPABASE_* env vars).
const SUPABASE_URL = 'https://qrpgvseyuyjwyccfjnju.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFycGd2c2V5dXlqd3ljY2Zqbmp1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE0OTMwNTEsImV4cCI6MjA4NzA2OTA1MX0.WfVCx9pxKISoZqvYqkYhSfSdUHVgScbMdZgqr3U9PwQ';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
